// extracted by mini-css-extract-plugin
export default {"fullWidth":"GgH2wlShQbMJSpsYGieh"};